import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=4996f392&scoped=true&"
import script from "./Reminder.vue?vue&type=script&lang=js&"
export * from "./Reminder.vue?vue&type=script&lang=js&"
import style0 from "./Reminder.vue?vue&type=style&index=0&id=4996f392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996f392",
  null
  
)

export default component.exports